import { Loader } from "../../../../components/loader/Loader";

export const TransparentLoader = ({ color }) => {
  return (
    <div className="fixed inset-0 z-[4000] bg-[#11152281] animate-slide-up 480:max-w-[440px] 480:mx-auto 480:flex 480:flex-col 480:justify-center h-screen ">
      <div className="grid place-self-center h-full">
        <Loader type="spinningBubbles" color={color ?? "#FFD700"} />
      </div>
    </div>
  );
};
